import AlertPage from "./AlertPage";

export default AlertPage;
